const phoneRegex = /^[0-9]{10}$/; // Only numbers, exactly 10 digits

export const vendorLoginSchema = () => {
    return (
        {
            phone: {
                type: 'text',
                label: 'Phone Number',
                validation: (value) => {
                    if (value.trim() === '') return 'Phone Number is required';
                    if (!phoneRegex.test(value)) return 'Invalid Phone Number';
                    return null;
                },
            },
        }
    )
}
